import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle } = FiIcons;

function ProgramCard({ program, featured = false }) {
  return (
    <motion.article
      className={featured ? 'program-card featured' : 'program-card'}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.25 }}
    >
      <span className="program-number">{program.number}</span>
      <p className="eyebrow">{program.subtitle}</p>
      <h2>{program.title}</h2>
      <p>{program.description}</p>
      <ul>
        {program.outcomes.map((outcome) => (
          <li key={outcome}>
            <SafeIcon icon={FiCheckCircle} />
            {outcome}
          </li>
        ))}
      </ul>
    </motion.article>
  );
}

export default ProgramCard;